/* eslint-disable react-hooks/exhaustive-deps */
import Checkbox from "@mui/material/Checkbox";
import FormControlLabel from "@mui/material/FormControlLabel";

import { IMode } from "../../../types/IModes";

const LogisticsRow = ({
  label,
  icon,
  mode,
  updateMode,
  children,
  disabled,
}: {
  label: string;
  icon: any;
  mode: IMode;
  updateMode?: (mode: IMode) => void;
  children?: React.ReactElement;
  disabled?: boolean;
}) => {
  return (
    <div id="logistics-row" style={{ padding: "0px 20px" }}>
      <div
        style={{
          display: "flex",
          alignItems: "center",
          gap: 20,
        }}
      >
        {icon}
        <div id='logistics-row-label' style={{ flexGrow: 1 }}>{label}</div>

        <FormControlLabel
          id="inbound-checkbox-form"
          label="Inbound"
          disabled={disabled}
          control={
            <Checkbox
              id="logistics-inbound-checkbox"
              style={{ padding: 0 }}
              value={mode.inbound}
              checked={mode.inbound}
              onChange={(e, checked) => {
                if (updateMode) {
                  updateMode({ ...mode, inbound: checked });
                }
              }}
            />
          }
        />
        <FormControlLabel
          id="outbound-checkbox-form"
          label="Outbound"
          disabled={disabled}
          control={
            <Checkbox
              id="logistics-outbound-checkbox"
              style={{ padding: 0 }}
              value={mode.outbound}
              checked={mode.outbound}
              onChange={(e, checked) => {
                if (updateMode) {
                  updateMode({ ...mode, outbound: checked });
                }
              }}
            />
          }
        />
      </div>
      {children}
    </div>
  );
};

export default LogisticsRow;
